<div class="alert-log-container">
  <h1>Journal d'alertes</h1>
  <div>
    <app-toggle-switch
      #switch
      [options]="[AlertLogEnum.TODO, AlertLogEnum.DONE]"
      [defaultOption]="AlertLogEnum.TODO"
      (currentOptionChange)="alertStatusChange($event)"
      data-testid="alert-log-toggle"
    ></app-toggle-switch>
  </div>

  <div class="search-container">
    <div class="text-input-search-container">
      <input
        class="search-input"
        #inputElement
        type="text"
        [(ngModel)]="inputValue"
        [placeholder]="
          AlertLogStatus.TODO === alertLogStatusSelected ? 'Catégorie, Message' : 'Traitée par, Catégorie, Message'
        "
        (keydown.enter)="getAlertsSearch(inputElement.value)"
        data-testid="search-input"
      />
      <app-icon
        class="icon-search-input"
        phosphorClass="ph-magnifying-glass"
        [size]="IconSize.medium"
        [iconStyle]="Style.bold"
      ></app-icon>
    </div>
    <div class="filter-container">
      <app-date-range-picker
        (startDateChange)="onStartDateChanged($event)"
        (endDateChange)="onEndDateChanged($event)"
      ></app-date-range-picker>
    </div>
    <div class="action-section">
      <app-button data-testid="export-button" [isDisabled]="isLoading" (onclick)="exportAlerts()">
        <app-icon phosphorClass="ph-export" tooltipText="Exporter les alertes" [tooltipPosition]="TooltipPosition.left"></app-icon>
      </app-button>
    </div>
  </div>

  <app-base-table
    data-testid="alerts-table"
    id="alerts-table"
    [tableLayoutAuto]="true"
    [source]="alertsSourceSearch"
    [isLoading]="isLoading"
  >
    <ng-container>
      <tr appRow *appRowHeaders></tr>
      <tr appRow class="readOnly" *appRowCells="let data; let i = index"></tr>
    </ng-container>

    <ng-container *appColumn="'etat'">
      <th appColumnHeader appSticky *appTableHeader>
        @if (AlertLogStatus.TODO === alertLogStatusSelected) {
          <app-column-header [name]="'Traiter'"></app-column-header>
        }
        @if (AlertLogStatus.DONE === alertLogStatusSelected) {
          <app-column-header
            [name]="'Traitée par'"
            type="filter"
            [filterItems]="filterItems.email!"
            field="email"
          ></app-column-header>
        }
      </th>

      <td data-testid="dealt-by" appCell appSticky *appTableCell="let data">
        @if (AlertLogStatus.TODO === data.status) {
          <div class="action-validate-buttons">
            <app-button
              [style]="ButtonStyle.Outlined"
              (onclick)="putAlert(data, AlertLogStatus.DONE)"
              [iconOptions]="{ phosphorClass: 'ph-stamp', position: ButtonIcon.OnlyIcon }"
            ></app-button>
          </div>
        }

        @if (AlertLogStatus.DONE === data.status) {
          <span class="etat">
            <p>{{ data.email }}</p>
          </span>
        }
      </td>
    </ng-container>

    <ng-container *appColumn="'closeDate'">
      <th appColumnHeader appSticky *appTableHeader>
        @if (AlertLogStatus.DONE === alertLogStatusSelected) {
          <app-column-header name="Traitée le" type="sort" field="closeDate"></app-column-header>
        }
      </th>
      <td data-testid="done-date" appCell appSticky *appTableCell="let data">
        @if (AlertLogStatus.DONE === alertLogStatusSelected) {
          <span [innerHTML]="data.closeDate | date: 'dd/MM/yyyy HH:mm' : 'Europe/Paris'"></span>
        }
      </td>
    </ng-container>

    <ng-container *appColumn="'level'">
      <th appColumnHeader appSticky *appTableHeader style="display: flex; justify-content: center">
        <app-column-header
          name="Niveau"
          type="filter"
          [filterTranslate]="getAlertLogLevel"
          field="level"
          [filterItems]="filterItems.level!"
        ></app-column-header>
      </th>
      <td data-testid="alert-level" appCell appSticky *appTableCell="let data">
        @if (data.level === AlertLogLevel.ERROR) {
          <app-icon
            data-testid="error-icon"
            phosphorClass="ph-warning-circle"
            [size]="IconSize.medium"
            [iconStyle]="Style.bold"
            [color]="Color.danger300"
          ></app-icon>
        }
        @if (data.level === AlertLogLevel.WARNING) {
          <app-icon
            data-testid="warning-icon"
            phosphorClass="ph-warning"
            [size]="IconSize.medium"
            [iconStyle]="Style.bold"
            [color]="Color.warning500"
          ></app-icon>
        }
      </td>
    </ng-container>

    <ng-container *appColumn="'date'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header name="Date" type="sort" sort="desc" field="timestamp"></app-column-header>
      </th>
      <td data-testid="alert-date" appCell appSticky *appTableCell="let data">
        <span [innerHTML]="data.timestamp | date: 'dd/MM/yyyy HH:mm' : 'Europe/Paris'"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'category'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-column-header
          name="Catégorie"
          type="filter"
          [filterTranslate]="getAlertCategory"
          field="category"
          [filterItems]="filterItems.category!"
        ></app-column-header>
      </th>
      <td data-testid="alert-category" appCell appSticky *appTableCell="let data">
        <span [innerHTML]="getAlertCategory(data.category)"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'message'">
      <th appColumnHeader *appTableHeader>
        <app-column-header name="Message" type="sort" field="message"></app-column-header>
      </th>
      <td data-testid="alert-message" appCell *appTableCell="let data">
        <span [innerHTML]="data.message"></span>
      </td>
    </ng-container>
  </app-base-table>
</div>
